export const prefix = process.env.NEXT_PUBLIC_CDN_URL ?? '';
